import { useContext } from 'react';
import LibraryContext from '../contexts/LibraryContext';

export const useLibraryContext = () => {
  return useContext(LibraryContext);
};
